var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',{on:{"click":_vm.logout}},[_c('v-list-item-title',[_vm._v("\n    Kilépés\n    "),_c('form',{ref:"logout",attrs:{"method":_vm.method,"action":_vm.route}},[_c('CsrfToken')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }